export default __webpack_public_path__ + "static/media/uin_table1.64bea5c8.png";